// libs
import get from 'lodash/get';

// helpers

export const getIsExpEnabledOnInternationalUser = (state: any) => {
  return !get(state, 'app.onIntlNetwork', false);
};
